import { HiBuildingOffice2 } from "react-icons/hi2";

export const linksAccountant = [
    { label:"Empresas", path:"/empresas", icon:HiBuildingOffice2 },
];